import React, { useContext } from 'react'
import withDialog, { WrappedProps } from 'shared/hocs/withDialog'
import styled, { ThemeContext } from 'styled-components'
import { lighten } from 'polished';

import flowRight from 'lodash/flowRight'
import Button from 'shared/components/Button'
import Box from 'shared/components/Box'

interface BasicDialogType {

}

type Props = WrappedProps<BasicDialogType> & {
  description?: string
  closeButton?: boolean
  formButton?: boolean
  closeLabel: string
}

function BasicDialog(props: Props) {
  const {
    onClose,
    onContinue,
    description,
    formButton = false,
    closeButton = false,
    closeLabel = 'Cancel'
  } = props

  const theme = useContext(ThemeContext)

  return (
    <BasicDialogBodyContainer className="confirm-dialog-container">
      {description && (
        <Box className="description">{description}</Box>
      )}
      {closeButton && (
        <StyledButton
          variant="primary"
          onClick={onClose}
          px="32px"
        >
          {closeLabel}
        </StyledButton>
      )}
      {formButton && (
        <StyledButton
          variant="primary"
          onClick={onContinue}
          width="180px"
        >
          Fill Form Now
        </StyledButton>
      )}
      {!closeButton && (
        <div className="dialog-button-close" onClick={onClose}>{closeLabel}</div>
      )}
    </BasicDialogBodyContainer>
  )
}

const WrappedBasicDialog = flowRight(withDialog())(BasicDialog)


const StyledButton = styled(Button)`
  margin: 40px auto 0;
`


const BasicDialogBodyContainer = styled(Box)`
  color: ${({ theme }) => theme.colors.secondary};
  padding: 40px;
  width: 100%;
  max-width: 540px;

  .description {
    width: 100%;
    text-align: center;

    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }

  .dialog-button-close {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;

    color: ${({ theme }) => theme?.colors?.main};
    text-decoration-line: underline;
    text-align: center;
    cursor: pointer;

    width: fit-content;
    margin: 40px auto 0;
  }

  .note-content {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    color: ${({ theme }) => theme?.colors?.secondary};

    margin-top: 1.5rem;
  }
`
export default WrappedBasicDialog
